import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          精选专题帮你快速找到想看的电影，总有一个专题适合你
        </p>
        <div className="space-y-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#cards');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 64;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{item.description}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs font-medium text-foreground-400 bg-background-200/70 px-2.5 py-1 rounded-full">
                  {item.count}部
                </span>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}